module.exports = __webpack_public_path__ + "static/img/yunyingmima.2e1878b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/yunyingmima.png
// module id = gxQg
// module chunks = 1